"use strict";
/**
 * Created by fan on 2/27/17.
 */
exports.__esModule = true;
var selector_1 = require("../../../../../../../../components/list-selector/app/js/logic/selector");
var table_selector_1 = require("../../../../../../../../components/table-selector/app/js/logic/table-selector");
var smartorg;
(function (smartorg) {
    var r6;
    (function (r6) {
        var acts;
        (function (acts) {
            var universal;
            (function (universal) {
                var schema;
                (function (schema) {
                    var logic;
                    (function (logic) {
                        var ListItem = selector_1["default"].ListItem;
                        var TableListItem = table_selector_1["default"].TableListItem;
                        /**
                         * For a list selector, it should has 2 to 4 list of items. Changed
                         * shows if it has been changed since loading.
                         */
                        var IOData = /** @class */ (function () {
                            function IOData() {
                                this.chosen = [];
                                this.notChosen = [];
                                this.changed = false;
                            }
                            return IOData;
                        }());
                        /**
                         * For a table selector, it should has table name, row and col
                         * headers. The chosen field is a combined value of row and col.
                         * Changed shows if it has been changed since loading.
                         */
                        var TableSelectorData = /** @class */ (function () {
                            function TableSelectorData(key, name, rowHeaders, colHeaders) {
                                this.key = key;
                                this.name = name;
                                this.rowHeaders = rowHeaders;
                                this.colHeaders = colHeaders;
                                this.changed = false;
                            }
                            return TableSelectorData;
                        }());
                        /**
                         * To handle the data binding with List/Table selector.
                         *
                         * Notice: An instance of object is doing two-way binding in the
                         * directive, so every member variable here is public.
                         */
                        var SchemaSelector = /** @class */ (function () {
                            function SchemaSelector() {
                                this.reset();
                            }
                            SchemaSelector.prototype.reset = function () {
                                this.inputData = undefined;
                                this.outputData = undefined;
                                this.selectedInputTable = undefined;
                                this.tinData = undefined;
                                this.selectedOutputTable = undefined;
                                this.toutData = undefined;
                                this.categoriesData = undefined;
                                this.status = {
                                    inputStatus: false,
                                    outputStatus: false,
                                    tinStatus: false,
                                    toutStatus: false,
                                    categoriesStatus: false,
                                    changed: false
                                };
                            };
                            /**
                             * Load selector data by given field list.
                             *
                             * Notice: Normal lists (input/output) are using ListItem, but
                             * tables are not using TableListItem. The reason is Table
                             * selector directive is getting row and col header first then
                             * create TableListItem within the directive.
                             *
                             * @param fieldList {FieldListData}
                             */
                            SchemaSelector.prototype.loadData = function (fieldList) {
                                this.reset();
                                this.fieldList = JSON.parse(JSON.stringify(fieldList));
                                // Load input
                                this.inputData = new IOData();
                                if (fieldList.inputs) {
                                    this.inputData.notChosen = fieldList.inputs.filter(function (item) { return item && item.key; }).map(function (item) { return new ListItem(item.key, item.display); });
                                }
                                // Load outputs
                                this.outputData = new IOData();
                                if (fieldList.outputs) {
                                    this.outputData.notChosen = fieldList.outputs.filter(function (item) { return item && item.key; }).map(function (item) { return new ListItem(item.key, item.display); });
                                }
                                // Load categories
                                this.categoriesData = new IOData();
                                if (fieldList.categories) {
                                    this.categoriesData.notChosen = fieldList.categories.filter(function (item) { return item && item.key; }).map(function (item) { return new ListItem(item.key, item.display); });
                                }
                                if (fieldList.tableInputs && fieldList.tableInputs.length > 0) {
                                    // Load table input. See notice in docs.
                                    this.tinData = fieldList.tableInputs.map(function (table) {
                                        return new TableSelectorData(table.key, table.name, table.rowHeaders.filter(function (item) { return item; }), table.colHeaders.filter(function (item) { return item; }));
                                    });
                                    this.selectedInputTable = undefined;
                                }
                                if (fieldList.tableOutputs && fieldList.tableOutputs.length > 0) {
                                    // Load table output
                                    this.toutData = fieldList.tableOutputs.map(function (table) {
                                        return new TableSelectorData(table.key, table.name, table.rowHeaders.filter(function (item) { return item; }), table.colHeaders.filter(function (item) { return item; }));
                                    });
                                    this.selectedOutputTable = undefined;
                                }
                            };
                            /**
                             * See if there is anything have been selected. That means if
                             * anything has been chosen. This is not about changes, it is
                             * to see if the chosen are valid.
                             *
                             * @return {boolean} If any field is chosen, return true.
                             */
                            SchemaSelector.prototype.checkFieldsStatus = function () {
                                this.status.inputStatus = this.inputData &&
                                    this.inputData.chosen.length > 0;
                                this.status.outputStatus = this.outputData &&
                                    this.outputData.chosen.length > 0;
                                this.status.tinStatus = false;
                                this.status.toutStatus = false;
                                if (this.tinData) {
                                    this.status.tinStatus = this.tinData.reduce(function (rs, item) {
                                        return rs || (item.chosen && item.chosen.length > 0);
                                    }, false) || false;
                                }
                                if (this.toutData) {
                                    this.status.toutStatus = this.toutData.reduce(function (rs, item) {
                                        return rs || (item.chosen && item.chosen.length > 0);
                                    }, false) || false;
                                }
                                this.status.categoriesStatus = this.categoriesData &&
                                    this.categoriesData.chosen.length > 0;
                                return this.status.inputStatus ||
                                    this.status.outputStatus ||
                                    this.status.tinStatus ||
                                    this.status.toutStatus ||
                                    this.status.categoriesStatus;
                            };
                            /**
                             * Match cells with given table row headers and col headers.
                             * Only return those existing row/cols pair.
                             *
                             * @param table {TableSelectorData}
                             * @param cellList {TableCell}
                             * @return {Array<TableListItem>}
                             */
                            SchemaSelector.prototype.getMatchedCells = function (table, cellList) {
                                var c = [];
                                cellList.forEach(function (cell) {
                                    if (table.rowHeaders.indexOf(cell.rowHeader) >= 0 &&
                                        table.colHeaders.indexOf(cell.colHeader) >= 0) {
                                        c.push(new TableListItem(cell.rowHeader, cell.colHeader));
                                    }
                                });
                                return c.length ? c : undefined;
                            };
                            /**
                             * Set a current status of all data by given schema data.
                             *
                             * If input or output key given by schema is not found, ignore
                             * those keys.
                             *
                             * If table given by schema is not found, ignore table.
                             *
                             * @param templateData {SchemaTemplateDetailData}
                             */
                            SchemaSelector.prototype.setCurrentStatus = function (templateData) {
                                // Reset lists
                                this.loadData(this.fieldList);
                                // Set data for selector (input)
                                if (templateData.inputKeys) {
                                    var inList_1 = this.inputData.notChosen;
                                    this.inputData.chosen = templateData.inputKeys.map(function (key) {
                                        return inList_1.find(function (item) { return item['key'] == key; });
                                    }).filter(function (item) { return item; });
                                    this.inputData.notChosen = inList_1.filter(function (item) {
                                        return templateData.inputKeys.indexOf(item['key']) < 0;
                                    });
                                }
                                // Set data for selector (output)
                                if (templateData.outputKeys) {
                                    var outList_1 = this.outputData.notChosen;
                                    this.outputData.chosen = templateData.outputKeys.map(function (key) {
                                        return outList_1.find(function (item) { return item['key'] == key; });
                                    }).filter(function (item) { return item; });
                                    this.outputData.notChosen = outList_1.filter(function (item) {
                                        return templateData.outputKeys.indexOf(item['key']) < 0;
                                    });
                                }
                                // Set data for selector (category)
                                if (templateData.categories) {
                                    var categoryList_1 = this.categoriesData.notChosen;
                                    this.categoriesData.chosen = templateData.categories.map(function (key) {
                                        return categoryList_1.find(function (item) { return item['key'] == key; });
                                    }).filter(function (item) { return item; });
                                    this.categoriesData.notChosen = categoryList_1.filter(function (item) {
                                        return templateData.categories.indexOf(item['key']) < 0;
                                    });
                                }
                                var _loop_1 = function (tableName) {
                                    if (templateData.inputTables.hasOwnProperty(tableName)) {
                                        var table = this_1.tinData.find(function (item) {
                                            return item.key == tableName;
                                        });
                                        // Table key in schema not found
                                        if (!table) {
                                            return "continue";
                                        }
                                        table.chosen = this_1.getMatchedCells(table, templateData.inputTables[tableName].cells);
                                    }
                                };
                                var this_1 = this;
                                // Set input table data
                                for (var tableName in templateData.inputTables) {
                                    _loop_1(tableName);
                                }
                                var _loop_2 = function (tableName) {
                                    if (templateData.outputTables.hasOwnProperty(tableName)) {
                                        var table = this_2.toutData.find(function (item) {
                                            return item.key == tableName;
                                        });
                                        // Table key in schema not found
                                        if (!table) {
                                            return "continue";
                                        }
                                        table.chosen = this_2.getMatchedCells(table, templateData.outputTables[tableName].cells);
                                    }
                                };
                                var this_2 = this;
                                // Set output table data
                                for (var tableName in templateData.outputTables) {
                                    _loop_2(tableName);
                                }
                            };
                            /**
                             * Update a schema, handling templates in given schema.
                             *
                             * @param sch {UniversalSchema}
                             * @param templateName {string}
                             * @param templateType {string}
                             */
                            SchemaSelector.prototype.updateSchema = function (sch, templateName, templateType) {
                                sch.setTemplateInputs(templateName, templateType, this.inputData.chosen.map(function (item) { return item['key']; }));
                                sch.setTemplateOutputs(templateName, templateType, this.outputData.chosen.map(function (item) { return item['key']; }));
                                sch.setTemplateCategories(templateName, templateType, this.categoriesData.chosen.map(function (item) { return item['key']; }));
                                var tinChanged = false;
                                if (this.tinData) {
                                    this.tinData.forEach(function (table) {
                                        if (table.chosen) {
                                            var cells_1 = [];
                                            table.chosen.forEach(function (item) {
                                                cells_1.push({ rowHeader: item.rowHeader, colHeader: item.colHeader });
                                            });
                                            sch.setTemplateInputTable(templateName, templateType, table.key, cells_1);
                                        }
                                        if (table.changed) {
                                            tinChanged = true;
                                        }
                                    });
                                }
                                var toutChanged = false;
                                if (this.toutData) {
                                    this.toutData.forEach(function (table) {
                                        if (table.chosen) {
                                            var cells_2 = [];
                                            table.chosen.forEach(function (item) {
                                                cells_2.push({ rowHeader: item.rowHeader, colHeader: item.colHeader });
                                            });
                                            sch.setTemplateOutputTable(templateName, templateType, table.key, cells_2);
                                        }
                                        if (table.changed) {
                                            toutChanged = true;
                                        }
                                    });
                                }
                                this.status.changed =
                                    this.inputData.changed ||
                                        this.inputData.changed ||
                                        tinChanged || toutChanged;
                            };
                            return SchemaSelector;
                        }());
                        logic.SchemaSelector = SchemaSelector;
                    })(logic = schema.logic || (schema.logic = {}));
                })(schema = universal.schema || (universal.schema = {}));
            })(universal = acts.universal || (acts.universal = {}));
        })(acts = r6.acts || (r6.acts = {}));
    })(r6 = smartorg.r6 || (smartorg.r6 = {}));
})(smartorg || (smartorg = {}));
exports["default"] = smartorg.r6.acts.universal.schema.logic;
//# sourceMappingURL=schema-selector.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/universal-io/app/schema-builder/app/js/logic/schema-selector.js